import React, {useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {RequestVisitorDto} from "../../../modules/vms/dto/RequestVisitorDto";
import {
    Card,
    CardHeader, Dialog, DialogActions,
    DialogContent,
    DialogTitle, Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "@mui/material";
import CloseButton from "../../../components/buttons/CloseButton";
import RequestVisitorDetail from "./RequestVisitorDetail";

export type RequestVisitorListProps = {
    visitors: Array<RequestVisitorDto>;
};

const RequestVisitorList: React.FC<RequestVisitorListProps> = (props) => {
    const intl = useIntl();
    const [selectedVisitor, setSelectedVisitor] = useState<RequestVisitorDto>(new RequestVisitorDto());
    const [openVisitorDetailDialog, setOpenVisitorDetailDialog] = useState(false);

    const handleVisitorDetail = async (record: RequestVisitorDto) => {
        setSelectedVisitor(record);
        setOpenVisitorDetailDialog(true);
    };

    return (
        <Card>
            <Dialog open={openVisitorDetailDialog} fullWidth={true} maxWidth={'lg'}>
                <DialogTitle>
                    {intl.formatMessage({id: 'VMS_REQUEST_VISITOR_DETAIL'})}
                </DialogTitle>
                <DialogContent>
                    <RequestVisitorDetail requestVisitor={selectedVisitor}/>
                </DialogContent>
                <DialogActions>
                    <CloseButton onClick={() => setOpenVisitorDetailDialog(false)}/>
                </DialogActions>
            </Dialog>
            <CardHeader title={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_LIST'})}/>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_NAME'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_EMAIL'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_EMPLOYEE_NO'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_COMPANY'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VISIT_CODE'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'COMMON_ACTION'})}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.visitors.map((row, index) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.fullName}</TableCell>
                            <TableCell>{row.mobile}</TableCell>
                            <TableCell>{row.email}</TableCell>
                            <TableCell>{row.remarks}</TableCell>

                            <TableCell>{row.company}</TableCell>
                            <TableCell>{row.visitCode}</TableCell>
                            <TableCell>
                                <Link href={'javascript:void(0)'} onClick={() => handleVisitorDetail(row)}>
                                    <FormattedMessage id={'COMMON_DETAIL'}/>
                                </Link>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Card>
    )
};

export default RequestVisitorList;